module.exports = __webpack_public_path__ + "static/media/fmdSmall.5f806b0b.jpg";